class FetchAiCostLimitAlerts {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiCostLimitAlerts;
